
import { graphql, gqlRequest, type ResultOf } from '@client/shared/graphql';

export const CancelBookingMutation = graphql(`
  mutation CancelBooking($bookingId: ID!) {
    cancelBooking(bookingId: $bookingId) {
      __typename
      id
    }
  }
`);

export type CancelBookingData = ResultOf<typeof CancelBookingMutation>;

export interface CancelBookingVars {
  readonly bookingId: string;
}

export function cancelBooking(
  vars: CancelBookingVars,
  signal?: AbortSignal,
): Promise<CancelBookingData> {
  return gqlRequest(CancelBookingMutation, vars, { signal });
}
